export default "/static/db6ed350be86982f.png"